import { NotificationState } from "../interfaces/notification-state.interface";
import { NotificationsResponse } from "../interfaces/notifications.interface";

export const initialState: NotificationState = {
  notifications: [
    {
      creationDate: "",
      isClosable: false,
      status: "warning",
      type: "default",
      content: "",
      header: "",
    },
  ],
  isLoading: false,
};

export const initialUserNotificationsState: NotificationsResponse = {
  userNotifications: null,
  pagination: null,
}
